<template>
  <div class="container py-5">

    <p>
    <b> 💉 醫美精準注射，從選擇對的針具開始！ </b>
    <br>TSK 日本製針劑技術，專為精細注射設計，確保高穩定度，讓每位醫師更加游刃有餘！
    <br><br><b>📌 為什麼不能錯過這場展會？</b><br>🔸 技術剖析｜深入了解 TSK 針具如何提升治療精準度<br>🔸 產品體驗｜現場感受TSK的極致工藝<br>🔸 專屬優惠｜展會限定促銷，讓我們提供最優惠的價格給您
    <br><br>📅 展會時間：2025/5/3 - 5/4 (六、日)<br>📍 展會地點：TICC 國際會議中心 4樓 D19<br><br>不容錯過的醫美盛會，期待您的蒞臨！
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_58.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
